module.exports = __webpack_public_path__ + "static/media/26UNRWA10.b82c54f9.jpg";